export const roomActions = {
  SET_ROOM: "SET_ROOM",
};

export function setRoomReducer(room) {
  return { type: roomActions.SET_ROOM, payload: room };
}